<script setup>
import { onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'

const router = useRouter()
const loading = ref(true)
const error = ref('')

// 从URL中解析查询参数
const getQueryParams = () => {
  const params = new URLSearchParams(window.location.search)
  return {
    code: params.get('code'), // 企微返回的授权code
    state: params.get('state'), // 可选，用于验证请求合法性
    appid: params.get('appid'), // 企微应用ID
  }
}

// 使用code换取用户信息
const exchangeCodeForToken = async (code, state) => {
  try {
    // 使用环境变量中的API基础URL
    const apiBaseUrl = import.meta.env.VITE_API_BASE_URL
    const response = await fetch(`${apiBaseUrl}/api/v1/auth/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code: code, state: state }),
    })

    if (!response.ok) {
      // 先解析响应体以获取 message
      const errorData = await response.json().catch(() => ({}))
      const errorMessage = errorData.error_message || errorData.message || '未知错误'
      throw new Error(`获取用户信息失败: ${errorMessage}${errorData.data}`)
    }

    return await response.json()
  } catch (error) {
    console.error('换取token失败:', error)
    throw error
  }
}

onMounted(async () => {
  try {
    const { code, state } = getQueryParams()

    // 验证参数是否存在
    if (!code) {
      throw new Error('未获取到授权code')
    }
    // 换取用户信息 - 同时传递code、state
    const userData = await exchangeCodeForToken(code, state)
    // 存储用户信息到本地 - 适配新的API响应格式
    if (userData.data && userData.data.token) {
      localStorage.setItem('wecom_access_token', userData.data.token)
      localStorage.setItem('is_authenticated', 'true')
    } else {
      throw new Error('授权成功，但未返回有效token信息')
    }

    // 跳转回主页或授权前的页面
    router.push('/') // 或从state中解析原跳转页面
  } catch (err) {
    error.value = err.message
    showToast(`授权失败: ${err.message}`)
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <div class="auth-callback-container"></div>
</template>
<style scoped>
.auth-callback-container {
  background-color: #f4f5fc;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.loading-text {
  color: #333;
  font-size: 16px;
}

.error-container {
  text-align: center;
  padding: 20px;
}

.error-text {
  color: #ff4d4f;
  font-size: 14px;
}
</style>

<style>
/* 全局样式，确保整个页面背景色 */
html,
body {
  background-color: #f4f5fc;
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
